import React from 'react';
import { Jumbotron as Jumbo, Container } from 'react-bootstrap';
import styled from 'styled-components';
import {Layout} from './components/Layout';
import {Jumbotron} from './components/Jumbotron8';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
const Styles=styled.div`


@media only screen and (max-width: 500px) {



.gif{
 max-width:50%;
height: 50%;
}


.text{
font-family: 'Open Sans', sans-serif;
padding: 10px;

}
.title{
font-family: 'Open Sans', sans-serif;
color:#0080b9;
padding: 1px;
}
.psd2{
max-width:100%;
height:auto;
}
.text1{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;
}
.email{
width:95%;
margin-top:30px;
margin-bottom:3px;
margin-left:50px;
margin-right:px;
border: 2px solid black;
}
.text2{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;
margin-bottom:150px;
}
.title2{

font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:50px;
margin-bottom:20px;
text-align:center;
margin-right:40px;
padding-top:40px;
color:#0080b9;
}
mark.blue{
	color:#0080b9;
	background: none;
	margin-left:-5px;
	font-weight:bold;
}
.design{
width:90%;
margin-top:-50px;
margin-right:30px;
margin-bottom:20px;
margin-left:20px;
border: 2px solid black;
}
.text3{
font-family: 'Open Sans', sans-serif;
margin-top:45px;
margin-bottom:100px;
margin-left:15px;
margin-right:15px;
text-align:left;
font-size:24px;
}
}

@media only screen and (min-width: 501px) {


.gif{
float:left;
width:70%;
padding: 50px;
margin-bottom:50px;
margin-right:50px;
margin-left:50px;
margin-top:50px;
}


.text{
font-family: 'Open Sans', sans-serif;
font-size: 24px;
padding:10px;
}

.text1{
font-family: 'Open Sans', sans-serif;
margin-right:900px;
margin-left:90px;
margin-top:50px;
margin-bottom:40px;
text-align:left;
font-size:24px;
}

.psd2{
float:right;
width:90%;
padding:5%;

}
.email{
max-width:100%;
padding:40px;
margin-bottom:50px;


}

.title{
font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
padding: 5px;

}
.text2{
font-family: 'Open Sans', sans-serif;
margin-top:100px;
text-align:left;
font-size:24px;
margin-right:30px;
margin-left:200px;
margin-bottom:400px;

}
.title2{
font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:350px;
text-align:right;
margin-left:675px;
color:#0080b9;
margin-right:300px;
margin-bottom:-40px;
}
mark.blue{
	color:#0080b9;
	background: none;
	margin-left:-5px;
	font-weight:bold;
}
.design{
float:right;
width:50%;
margin-top:-30px;
margin-right:50px;
margin-bottom:200px;
margin-left:60px;
border: 2px solid black;
}
.text3{
font-family: 'Open Sans', sans-serif;
margin-top:550px;
margin-bottom:100px;
margin-left:100px;
text-align:left;
font-size:24px;
}
}

`;
export const InvitationHomes = () => (
<React.Fragment>
	<Styles>

			<Jumbotron />

	<Container fluid>
	<img src={require('./assets/invlogo.jpeg')} alt="Invitation Logo" Class="gif"/> 
	

<Row>
	<Col>
<div class="text">
	<p>I started my journey at IH as a delivery manager within the technology department. My responsibilities started with organizing and executing technology-owned projects for the company and leading the technology department's agile transformation. </p>
	
	<p>After executing a variety of projects, I transitioned into a more elevated delivery role. In this new position, I would be responsible for the end-to-end delivery of projects for the company. Alongside this newly created delivery role, I would continue to lead the tactical day-to-day activities & ceremonies of my technology team, while also execting & evolving the long-term strategy of holistic delivery.</p>
		
	<p>Finally, I was promoted to the product organization within technology, where I create scalable solutions to drive operational efficiency.</p>

	<p> I was also part of the winning team for the very first annual Hackathon held by the technology department in 2021 🏆.</p>
	

</div>
</Col>
</Row>
</Container>

<Container fluid>
<Row>
<Col>
		<div class="title"> Toolbelt </div>
<div class="text">
<p>The bread and butter of our business is to get houses ready for residents to rent. As we acquired homes or as residents moved out of homes we already owned, we needed to scope each house to ensure that it was ready for the next tenant. At the time, the current-state scoping tool was a legacy one built back in 2015. </p>
<p>As the head of product for the RTM (Rehab, Turns, Maintenance), I led a team for 18 months to build out the MVP solution to replace the current-state tool; the new one is known as Toolbelt. The scope of the MVP delivery was a like-for-like mobile application (the ability to scope a home), with a few enhancements</p> 	
<p> The MVP app featured a breakdown of each item in categories, an enhanced, dynamic catalog that allowed users to pick items with ease, and a guided experience for some of our largest cost categories (i.e paint).</p>


</div>
</Col>
<Col>
<img src={require('./assets/paintgif.gif')} alt="Paint Scope" Class="psd2" /> 	

</Col>
</Row>

<Row>
<Col>
<img src={require('./assets/salesforce.png')} alt="Salesforce" Class="gif" /> 	  
</Col>
<Col>
			<p><div class="title"> Other Projects </div></p>

<div class="text">
<p>While I don't have any fancy gifs or artifacts for these other solutions I delivered, here's a list! The majority of these solutions were built upon our Salesforce platform.</p>
<p>
<li> Delivered technology to support a 375M Joint Venture effort with <a href= "https://www.businesswire.com/news/home/20201007005142/en/Invitation-Homes-Announces-375-Million-Joint-Venture-with-Rockpoint-to-Acquire-Single-Family-Rental-Homes">Rockpoint</a> </li> 
<li> Delivered technology to support outbound vendor payments; deprecating legacy payments service and allowing each vendor to be paid by job</li>
<li> Generated a total of $23M additional ancillary revenue by building software to support pet fees and air filter fees </li>
<li> Migrated HRIS system from ADP to Workday</li>
<li> Increased system up-time and enhanced customer experience by deploying a new journey for leasing application and resident profile creation </li>
</p>
</div>
</Col>

</Row>

</Container>
</Styles>
	</React.Fragment>
	)